import { render } from "./InputImageFileMobile.vue?vue&type=template&id=70083583&scoped=true&ts=true"
import script from "./InputImageFileMobile.vue?vue&type=script&lang=ts"
export * from "./InputImageFileMobile.vue?vue&type=script&lang=ts"

import "./InputImageFileMobile.vue?vue&type=style&index=0&id=70083583&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70083583"]])

export default __exports__